const profilePathPattern = /^\/(?:m\/)?profile(?:\/|$)/

export function isProfilePath(path: string): boolean {
  return profilePathPattern.test(path)
}

export function getProfileRootPath(path: string): '/profile' | '/m/profile' {
  return path === '/m' || path.startsWith('/m/') ? '/m/profile' : '/profile'
}
